import { InstituteApi } from "@/api";

export async function getAll() {
  const { data } = await InstituteApi.getInstitutesList();
  return data;
}
